import ApiService from './api.service'

const PowAccessPointService = {

  /***
   * Get Access Points
   * @returns {*}
   */
  get () {
    return ApiService.get('pow-access-point', '')
  },
}
export default PowAccessPointService
